import React from "react";

import {store} from "@risingstack/react-easy-state";
const Globals = store({loggedIn:false,barcode:null});
export default Globals;
